export default __webpack_public_path__ + "static/media/_DUA5002.e58d3520.jpg";